import React from 'react';

const DatesProgressBar = ({ startDate, endDate }) => {
  const start = startDate.valueOf();
  const end = endDate.valueOf();
  const now = new Date().getTime();
  const total = end - start;
  const current = now - start;

  const result = () => {
    if (start > now) return 0;
    if (end < now) return 100;

    return Math.round((current / total) * 100);
  };

  const bg = (val) => {
    switch (true) {
      case val >= 0 && val <= 24.99:
        return '#C35D5D';
      case val >= 25 && val <= 49.99:
        return '#F7A021';
      case val >= 50 && val <= 74.99:
        return '#B6D673';
      case val >= 75 && val <= 100:
        return '#82C2A5';
      default:
        return 'grey';
    }
  };

  return (
    <div
      style={{
        width: '100%',
        height: '12px',
        borderRadius: '2px',
        boxShadow: '0px 4px 4.300000190734863px 0px #0000001A inset',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: `${result()}%`,
          height: '12px',
          background: bg(result()),
        }}
      ></div>
    </div>
  );
};

export default DatesProgressBar;
